import { render, staticRenderFns } from "./AdminAssets.vue?vue&type=template&id=7059f46d"
import script from "./AdminAssets.vue?vue&type=script&lang=js"
export * from "./AdminAssets.vue?vue&type=script&lang=js"
import style0 from "./AdminAssets.vue?vue&type=style&index=0&id=7059f46d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports